const GOOGLE_FONTS_BASE = 'https://fonts.googleapis.com/css2';
const LINK_ATTR = 'data-brand-font';

/**
 * Dynamically load a Google Font by injecting a <link> tag into <head>.
 * Deduplicates — won't add if the same font is already loaded.
 */
export function loadGoogleFont(fontFamily: string): void {
  if (!fontFamily) return;

  // Check if already loaded
  const existing = document.querySelector(`link[${LINK_ATTR}="${fontFamily}"]`);
  if (existing) return;

  // Remove any previously loaded brand font
  const previous = document.querySelector(`link[${LINK_ATTR}]`);
  if (previous) {
    previous.remove();
  }

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = `${GOOGLE_FONTS_BASE}?family=${encodeURIComponent(fontFamily)}:wght@300;400;500;600;700&display=swap`;
  link.setAttribute(LINK_ATTR, fontFamily);
  document.head.appendChild(link);
}

/**
 * Remove a previously loaded brand font <link> tag.
 */
export function unloadFont(): void {
  const link = document.querySelector(`link[${LINK_ATTR}]`);
  if (link) {
    link.remove();
  }
}
